<template>
  <div>
    <div>
      <div class="box_wheel_bolao">
        <div class="wheel_bolao_detail">
          <div class="readonly-game">
            <div class="grid-tens-bolao-wheel">
              <animated-place-holder
                :height="'320px'"
                :maxwidth="'485px'"
                :borderradius="'15px'"
              ></animated-place-holder>
            </div>
          </div>
        </div>
      </div>
      <div class="box_all_cards_bolao mt-2">
        <animated-place-holder
          :height="'40px'"
          :maxwidth="'560px'"
          :borderradius="'15px'"
        ></animated-place-holder>
        <animated-place-holder
          class="ml-2"
          :height="'40px'"
          :maxwidth="'560px'"
          :borderradius="'15px'"
        ></animated-place-holder>
      </div>
    </div>
  </div>
</template>
<style src="./BoxBolaoInfo.scss" scoped></style>
<script>
import AnimatedPlaceHolderVue from '@components/Skeleton/AnimatedPlaceHolder.vue';

export default {
  components: {
    'animated-place-holder': AnimatedPlaceHolderVue
  }
};
</script>
